"use strict";

// Canva integration constants + helpers.

var CANVA_EXPORT_URL_PATTERN = /^https:\/\/export(?:-[a-z0-9]+)*\.canva\.com\//i;

var CANVA_DESIGN_ID_PATTERN = /^[A-Za-z0-9_-]+$/;

var CanvaMessageType = {
  EXPORT_COMPLETE: "CANVA_EXPORT_COMPLETE"
};

// Where to send the user when they click the Canva button.
// An existing design resumes editing; otherwise we start a new one.
function getCanvaRedirectUrl(designId) {
  return designId
    ? `/canva/navigate/${encodeURIComponent(designId)}`
    : "/canva/create-design";
}

// Validates the message posted back by the /canva/return tab.
function isCanvaExportCompleteMessage(data) {
  if (!data || typeof data !== "object") {
    return false;
  }

  var type = data.type;
  var payload = data.payload;
  if (type !== CanvaMessageType.EXPORT_COMPLETE) {
    return false;
  }
  if (!payload || typeof payload !== "object") {
    return false;
  }

  var exportUrls = payload.exportUrls;
  var designId = payload.designId;
  if (
    typeof designId !== "string" ||
    designId.length === 0 ||
    !CANVA_DESIGN_ID_PATTERN.test(designId)
  ) {
    return false;
  }
  if (!Array.isArray(exportUrls) || exportUrls.length === 0) {
    return false;
  }

  return exportUrls.every(function(url) {
    return typeof url === "string" && CANVA_EXPORT_URL_PATTERN.test(url);
  });
}

module.exports = {
  CANVA_EXPORT_URL_PATTERN,
  CANVA_DESIGN_ID_PATTERN,
  CanvaMessageType,
  getCanvaRedirectUrl,
  isCanvaExportCompleteMessage
};
